/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { RadioGroup } from '@headlessui/react'
import { toLocaleCurrency } from 'utils/dinero'
import { trackEvent } from 'analytics/trackFunctions'
import { Plan } from 'types/api/loan'
import Badge from 'components/Badge'
import { Checkbox } from '../Checkbox'

interface InstallmentCardProps {
  installment: Plan
  idx: number
  originalRate?: number
  interestFree?: boolean
}

const InstallmentCard = ({
  installment,
  idx,
  originalRate = null,
  interestFree = false
}: InstallmentCardProps) => (
  <RadioGroup.Option className='focus:outline-none' value={installment}>
    {({ checked }) => (
      <li
        className={`cursor-pointer transition-all relative duration-300 ease-in-out bg-white w-full px-3 py-4 my-2 rounded-lg border border-gray-500 flex justify-center items-center focus:outline-none ${
          !!checked && 'ring-2 border-green-800 ring-green-800'
        }`}
        onClick={() => {
          trackEvent({
            eventName: `nuevo_renov_oferta_click_${installment.installments_quantity}_cuotas`
          })
        }}
      >
        {idx === 0 && !interestFree && (
          <Badge className='absolute -top-4 right-0'>
            <span>Mejor tasa 🔥</span>
          </Badge>
        )}
        <Checkbox checked={checked} className='mr-4' />
        <div
          className={`flex-grow flex items-center justify-between font-extrabold text-xs ${
            checked ? 'text-[#08724C]' : 'text-black'
          }`}
        >
          <p>
            {installment.installments_quantity}{' '}
            {installment.installments_quantity > 1 ? 'cuotas' : 'cuota'}
          </p>
          <div className='text-right'>
            <p>$ {toLocaleCurrency(installment.payment_amount)}</p>
            <p className='leading-[.875rem] text-2xs text-gray-900 font-medium'>
              Tasa{' '}
              {originalRate ? (
                <span className='line-through text-gray-500 mx-[2px]'>
                  {(Number(originalRate) * 100).toFixed()}%
                </span>
              ) : null}{' '}
              {(Number(installment.interest_rate) * 100).toFixed()}%
            </p>
          </div>
        </div>
      </li>
    )}
  </RadioGroup.Option>
)

export default InstallmentCard
